import { render, staticRenderFns } from "./card-strategy.component.vue?vue&type=template&id=36b2a6b8&scoped=true"
import script from "./card-strategy.component.vue?vue&type=script&lang=js"
export * from "./card-strategy.component.vue?vue&type=script&lang=js"
import style0 from "./card-strategy.component.vue?vue&type=style&index=0&id=36b2a6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2a6b8",
  null
  
)

export default component.exports